/**
 * Created by AlexanderC on 1/21/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sandbox = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _domain = require('domain');

var _domain2 = _interopRequireDefault(_domain);

var _process = require('process');

var _process2 = _interopRequireDefault(_process);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let Sandbox = exports.Sandbox = function () {
  /**
   * @param {Function} func
   */
  function Sandbox(func) {
    _classCallCheck(this, Sandbox);

    this._func = func;
    this._onFail = Sandbox.ON_FAIL_CB;
  }

  /**
   * @returns {Function}
   */


  _createClass(Sandbox, [{
    key: 'run',


    /**
     * @returns {Sandbox}
     */
    value: function run() {
      let execDomain = _domain2.default.create();
      let failCbTriggered = false;

      let failCb = error => {
        if (failCbTriggered) {
          return;
        }

        failCbTriggered = true;

        try {
          execDomain.exit();
        } catch (e) {/* silent fail */}

        setImmediate(() => {
          this._onFail(error);
        });
      };

      execDomain.once('error', failCb);

      // lambda predefined listeners forces "Process exited ..." error
      _process2.default.removeAllListeners('uncaughtException');
      _process2.default.removeAllListeners('unhandledRejection');
      _process2.default.on('uncaughtException', failCb);
      _process2.default.on('unhandledRejection', failCb);

      try {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        execDomain.run.apply(execDomain, [this._func].concat(args));
      } catch (error) {
        failCb(error);
      }

      return this;
    }

    /**
     * @param {Function} cb
     * @returns {Sandbox}
     */

  }, {
    key: 'fail',
    value: function fail(cb) {
      this._onFail = cb;

      return this;
    }

    /**
     * @returns {Function}
     */

  }, {
    key: 'func',
    get: function get() {
      return this._func;
    }
  }], [{
    key: 'ON_FAIL_CB',
    get: function get() {
      return error => {
        console.error(error);
      };
    }
  }]);

  return Sandbox;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/Runtime/Sandbox.js
// module id = 168
// module chunks = 0